import React, { useState } from "react";
import funnelIcon from "../../icon/Funnel.svg";
import "../../style/typography.scss";
import Popover from "../Popover";
import Button from "../Button";
import PropTypes from "prop-types";
import Checkbox from "../Checkbox";
import clearIcon from "../../icon/X.svg"

/**
 * Filter button component that displays a toggleable list of columns in popover when clicked.
 *
 * @param {object} props - React props object
 * @param {object[]} props.filterColumns - Array of filterable column names
 * @param {function(object[])} props.setFilterColumns - Callback to set filtered columns
 */
function FilterButton({ filterColumns, setFilterColumns }) {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    return (
        <Popover
            isOpen={isPopoverOpen}
            showArrow
            onClickOutside={() => setIsPopoverOpen(false)}
            contentStyle={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
            }}
            content={
                <>
                    {Object.entries(filterColumns).map(([id, column]) => (
                        <Checkbox className="text-xs py-1" label={column.label} value={column.value} onChange={(value) => {
                            setFilterColumns({
                                ...filterColumns,
                                [id]: {
                                    label: column.label,
                                    value,
                                },
                            });
                        }}/>
                    ))}
                    {
                        Object.values(filterColumns).every(column => column.value === false) ||
                        <Button svg={clearIcon} className="btn-primary btn-xs text-sm" onClick={() => {
                            Object.keys(filterColumns).forEach(id => filterColumns[id].value = false);
                            setFilterColumns({...filterColumns});
                        }}>Clear All</Button>
                    }
                </>
            }
        >
            <Button
                svg={funnelIcon}
                className={
                    (Object.values(filterColumns).every(column => column.value === false) ?
                    "btn-secondary-gray" : "btn-secondary") + " btn-xs" }
                onClick={(e) => {
                    e.stopPropagation();
                    setIsPopoverOpen(!isPopoverOpen);
                }}
            />
        </Popover>
    );
}

FilterButton.propTypes = {
    actions: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            onClick: PropTypes.func.isRequired,
        }),
    ).isRequired,
};

export default FilterButton;
